import { makeAutoObservable, runInAction } from 'mobx'
import { apiService } from '@/services/Api'
import {
  GetUserNotificationsNotificationTypeEnum,
  UserNotification,
} from '@/services/Api/generated'
import { Loader } from '@/helpers/Loader'

export class NotificationStore {
  list: UserNotification[] = []

  setList(list: UserNotification[]) {
    this.list = list
  }

  loading = false
  startLoading() {
    this.loading = true
  }
  stopLoading() {
    this.loading = false
  }

  unreadCount: number = 0

  get hasUnread() {
    return this.unreadCount !== 0
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  loaderList = new Loader(async () => {
    const response = await apiService.user.getUserNotifications({
      notificationType: GetUserNotificationsNotificationTypeEnum.Unread,
      page: 1,
      perPage: 5,
    })
    if (response.status) {
      this.setList(response.data)
      this.unreadCount = response.meta.unread
    }
  })

  indexPeriodicUpdates: ReturnType<typeof setInterval>
  stopPeriodicUpdates() {
    clearInterval(this.indexPeriodicUpdates)
  }
  startPeriodicUpdates() {
    this.loaderList.request()
    this.stopPeriodicUpdates()

    this.indexPeriodicUpdates = setInterval(() => {
      if (!this.loading) {
        this.loaderList.request()
      }
    }, 180000)
  }

  loaderMarkAsRead = new Loader(async (id: UserNotification['id']) => {
    const response = await apiService.user.readUserNotification({
      notification: id,
    })
    if (response.status) {
      runInAction(() => {
        this.list = this.list.map((notification) => {
          if (notification.id === id) {
            return {
              ...notification,
              readAt: String(new Date()),
            }
          }
          return notification
        })
      })
    }
    return response
  })
}
